import { api } from "src/shared/setup/API/api";

export const useGetSheetLeads = async () => {
  try {
    const response = await api.get("/leads/export-sheet", {
      responseType: "blob", // importante para arquivos binários
    });

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;

    // tenta extrair o nome do arquivo do header
    const contentDisposition = response.headers["content-disposition"];
    let fileName = `leads_${new Date().toISOString()}.xlsx`;
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?([^"]+)"?/);
      if (match?.[1]) {
        fileName = match[1];
      }
    }

    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();

    // libera o objeto blob da memória
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Erro ao baixar o Excel", error);
  }
};
